
import { Skeleton } from "@/components/ui/skeleton";
import { AuthCheck } from "@/components/auth/AuthCheck";
import { ProgramDetailWrapper } from "./ProgramDetailWrapper";

interface ProgramDetailLoadingProps {
  avatarUrl: string;
  name: string;
}

export function ProgramDetailLoading({ avatarUrl, name }: ProgramDetailLoadingProps) {
  return (
    <AuthCheck>
      <ProgramDetailWrapper avatarUrl={avatarUrl} name={name}>
        <main className="p-6">
          <div className="animate-slide-in space-y-6">
            {/* Loading Header */}
            <div className="flex items-center justify-between">
              <div className="space-y-2">
                <Skeleton className="h-8 w-64 bg-white/10" />
                <Skeleton className="h-4 w-40 bg-white/10" />
              </div>
              <Skeleton className="h-10 w-36 bg-white/10" />
            </div>
            
            {/* Loading Content */}
            <Skeleton className="h-[500px] w-full bg-white/10" />
            
            {/* Loading Actions */}
            <Skeleton className="h-24 w-full bg-white/10" />
          </div>
        </main>
      </ProgramDetailWrapper>
    </AuthCheck>
  );
}
